import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CustomObject } from "../models/customObject.model";
import { ToastService } from "./toast.service";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { CustomField } from "../models/customField.model";
import { CustomObjectTypeEnum } from "../enums/customObjectType.enum";
import { Enum } from "../models/enum.model";
import { CustomObjectLookup } from "../models/customObjectLookup.model";
import { CrudService } from "../shared/grid/crud.service";

@Injectable({
    providedIn: "root",
})
export class CustomObjectService extends CrudService<CustomObject> {
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("CustomObject", http);
    }

    override getAll(filterBy: string = ""): Observable<CustomObjectLookup[]> {
        return super.getAll(filterBy) as Observable<CustomObjectLookup[]>;
    }

    getTypeLookup(
        type: CustomObjectTypeEnum,
    ): Observable<CustomObjectLookup[]> {
        return this.http
            .get<
                CustomObjectLookup[]
            >(this.getApiUrl(`CustomObject/GetTypeLookup?type=${type}`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading types",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getCustomObjectFields(id: number | string): Observable<CustomField[]> {
        return this.http
            .get<
                CustomField[]
            >(this.getApiUrl(`CustomObject/GetCustomObjectFields?id=${id}`))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading custom fields",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getCustomObjectTypes(): Observable<Enum[]> {
        return this.http
            .get<Enum[]>(this.getApiUrl("CustomObject/GetCustomObjectTypes"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading custom object types",
                        true,
                    );
                    return of([]);
                }),
            );
    }

    getCustomFieldTypes(): Observable<Enum[]> {
        return this.http
            .get<Enum[]>(this.getApiUrl("CustomObject/GetCustomFieldTypes"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading custom field types",
                        true,
                    );
                    return of([]);
                }),
            );
    }
}
